import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import { Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, TextField, Pagination } from "@mui/material";
import axios from "axios";
import { useEffect, useState, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import swal from "sweetalert";
import { t } from "i18next";
import { Link } from "react-router-dom";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import TaskAltRoundedIcon from "@mui/icons-material/TaskAltRounded";
import CreditCardRoundedIcon from "@mui/icons-material/CreditCardRounded";
import SyncRoundedIcon from "@mui/icons-material/SyncRounded";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import NumbersRoundedIcon from "@mui/icons-material/NumbersRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import FileDownloadRoundedIcon from "@mui/icons-material/FileDownloadRounded";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import React from "react";

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
    <input
        ref={ref}
        value={value || ""}
        onClick={onClick}
        placeholder="YYYY-MM-DD"
        className="ax-date-input"
        readOnly
    />
));

const mapBankName = (name) => {
    if (!name) return "-";
    const str = String(name).trim();
    if (str.toUpperCase().startsWith("V8PAY")) return str;
    const upper = str.toUpperCase();

    if (upper === "VCB" || upper === "VIETCOMBANK") return "Vietcombank";
    if (upper === "MB" || upper === "MBBANK") return "MBBank";
    if (upper === "CTG" || upper === "VIETINBANK") return "VietinBank";
    if (upper === "STB" || upper === "SACOMBANK") return "Sacombank";
    if (upper === "TCB" || upper === "TECHCOMBANK") return "Techcombank";
    if (upper === "ACB") return "ACB";
    if (upper === "BIDV") return "BIDV";
    if (upper === "VPB" || upper === "VPBANK") return "VPBank";
    if (upper === "VIB") return "VIB";
    if (upper === "TPB" || upper === "TPBANK") return "TPBank";
    if (upper === "AGB" || upper === "AGRIBANK" || upper === "VBA") return "Agribank";
    if (upper === "SHB") return "SHB";
    if (upper === "HDB" || upper === "HDBANK") return "HDBank";
    if (upper === "MSB") return "MSB";
    if (upper === "OCB") return "OCB";
    if (upper === "LPB" || upper === "LPBANK") return "LPBank";
    if (upper.includes("MOMO")) return "MoMo";
    if (upper.includes("ZALO")) return "ZaloPay";
    if (upper.includes("VIETTEL")) return "ViettelPay";

    return str;
};

function Add() {
    function formatDate(m) {
        if (!m) return "";
        const d = new Date(m);
        if (isNaN(d.getTime())) return "";
        const hh = String(d.getHours()).padStart(2, "0");
        const mm = String(d.getMinutes()).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${hh}:${mm} ${day}-${month}-${year}`;
    }

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [note, setNote] = useState("");
    const [profile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searched, setSearched] = useState("");
    const [startDate, setStartDate] = useState(() => {
        const d = new Date();
        d.setDate(d.getDate() - 7);
        return d;
    });
    const [endDate, setEndDate] = useState(() => new Date());
    const [status, setStatus] = useState("All");
    const [method, setMethod] = useState("All");
    const [type, setType] = useState("All");
    const [isGuideOpen, setIsGuideOpen] = useState(false);
    const [selectedDetailItem, setSelectedDetailItem] = useState(null);
    const [maGiaoDich, setMaGiaoDich] = useState("");
    const limit = 50;
    const typingTimeoutRef = useRef(null);

    // States thống kê
    const [totalSuccess, setTotalSuccess] = useState(0);
    const [totalPending, setTotalPending] = useState(0);
    const [totalFailed, setTotalFailed] = useState(0);
    const [totalKm, setTotalKm] = useState(0);

    // Denial popup states
    const [denyModalOpen, setDenyModalOpen] = useState(false);
    const [denyItem, setDenyItem] = useState(null);
    const [denyReason, setDenyReason] = useState("");
    const [recentReasons, setRecentReasons] = useState(() => {
        const saved = localStorage.getItem("happy_recent_cancel_reasons");
        if (saved) {
            try { return JSON.parse(saved); } catch (e) { }
        }
        return ["CHƯA ĐỦ CƯỢC", "NGÂN HÀNG ĐANG BẢO TRÌ", "SAI THÔNG TIN NGÂN HÀNG"];
    });

    const saveReason = (reasonText) => {
        if (!reasonText || !reasonText.trim()) return;
        const trimmed = reasonText.trim();
        if (!recentReasons.includes(trimmed)) {
            const updated = [trimmed, ...recentReasons].slice(0, 10);
            setRecentReasons(updated);
            localStorage.setItem("happy_recent_cancel_reasons", JSON.stringify(updated));
        }
    };

    const deleteReason = (reasonToDelete, e) => {
        e.stopPropagation();
        const updated = recentReasons.filter(r => r !== reasonToDelete);
        setRecentReasons(updated);
        localStorage.setItem("happy_recent_cancel_reasons", JSON.stringify(updated));
    };

    const handleConfirmDeny = (item, reason) => {
        if (!item) return;
        setLoading(true);
        if (reason && reason.trim()) {
            saveReason(reason.trim());
        }
        axios.post(`${process.env.REACT_APP_API_URL}/payment/update`, {
            id: item._id,
            status: "Deny",
            note: reason || "Từ chối"
        })
            .then(() => {
                swal(t("success"), "Đã từ chối đơn nạp thành công!", "success");
                fetchPayments();
                setDenyModalOpen(false);
                setSelectedDetailItem(null);
            })
            .catch((err) => {
                swal(t("error"), err.response?.data?.message || "Có lỗi xảy ra", "error");
                setLoading(false);
            });
    };

    // Timezone-safe local date formatter (YYYY-MM-DD)
    const formatLocalDate = (date) => {
        if (!date) return "";
        const offset = date.getTimezoneOffset();
        const localDate = new Date(date.getTime() - (offset * 60 * 1000));
        return localDate.toISOString().split('T')[0];
    };

    // Helper parse Ghi chú & Nội dung chuyển khoản
    const parseTransactionInfo = (item) => {
        let noteText = item?.note || "";
        let codeText = item?.code || item?.noidung || "";

        if (noteText && noteText.toLowerCase().includes("code:")) {
            const match = noteText.match(/^(.*?)(?:\s*code:\s*([A-Za-z0-9]+))?$/i);
            if (match && match[2]) {
                noteText = match[1].trim();
                if (!codeText) codeText = match[2].trim();
            }
        }

        const isFailedOrCanceled = item?.status_payment === "Cancel" || item?.status_payment === "Cancelled" || item?.status_payment === "Deny" || item?.status_payment === "Failed";

        if (isFailedOrCanceled) {
            if (!noteText || /^Nạp/i.test(noteText) || /^Chờ/i.test(noteText) || noteText === "Thất bại" || noteText === "Từ chối") {
                noteText = "Quá hạn";
            }
        } else if (!noteText || /^Nạp tự động/i.test(noteText)) {
            noteText = (item?.status_payment === "Success" || item?.status_payment === "Accept") ? "Thành công" : "Chờ xử lý";
        }

        return { cleanNote: noteText || "-", extractedCode: codeText || "-" };
    };

    const getDepositTypeLabel = (item) => {
        if (!item) return "Tự động";

        const ch = String(item?.channel || "").trim();
        const bk = String(item?.bank || item?.name_bank || "").trim();
        const tp = String(item?.type || "").trim();
        const dt = String(item?.detail || "").trim();

        const isManual =
            ch === "Manual Deposit" ||
            bk === "Manual Deposit" ||
            ch.toLowerCase().includes("manual") ||
            bk.toLowerCase().includes("manual") ||
            tp.toLowerCase() === "manual" ||
            dt.toLowerCase().includes("manual") ||
            ch.includes("thủ công") ||
            bk.includes("thủ công") ||
            tp.includes("thủ công") ||
            item?.is_auto === false;

        return isManual ? "Thủ công" : "Tự động";
    };

    const parseDetailTransaction = (item) => {
        if (!item) return { bankName: "-", accountName: "-", accountNumber: "-", displayType: "Tự động", methodType: "Ngân hàng", codeText: "-", cleanNote: "-" };

        let bankName = (item?.channel && !item.channel.includes("Manual")) ? item.channel : (item?.bank || item?.name_bank || "-");
        let accountName = item?.name || item?.name_user || "-";
        let accountNumber = item?.stk || item?.accountNumber || "-";
        let displayType = getDepositTypeLabel(item);

        const rawDetail = String(item?.detail || "");
        let methodType = "Ngân hàng";

        if (rawDetail.includes(" - ")) {
            const parts = rawDetail.split(" - ");
            if (parts.length >= 3) {
                bankName = parts[0].trim();
                accountName = parts[1].trim();
                accountNumber = parts.slice(2).join(" - ").trim();
            } else if (parts.length === 2) {
                bankName = parts[0].trim();
                if (!parts[1].toLowerCase().startsWith("code:")) {
                    accountNumber = parts[1].trim();
                }
                accountName = "-";
            }
        }

        if (item?.stk || item?.accountNumber) {
            accountNumber = item.stk || item.accountNumber;
        }

        if (rawDetail.toUpperCase().includes("USDT") || rawDetail.toUpperCase().includes("CRYPTO") || bankName.toUpperCase().includes("USDT")) {
            methodType = "Tiền điện tử";
        }

        const { cleanNote, extractedCode } = parseTransactionInfo(item);

        return {
            bankName: mapBankName(bankName),
            accountName: accountName,
            accountNumber: accountNumber,
            displayType: displayType,
            methodType: methodType,
            codeText: item?.code || item?.noidung || extractedCode || "-",
            cleanNote: cleanNote || item?.note || "Thành công"
        };
    };

    // Hàm gọi API
    const fetchPayments = () => {
        setLoading(true);
        const startStr = formatLocalDate(startDate);
        const endStr = formatLocalDate(endDate);
        axios
            .get(`${process.env.REACT_APP_API_URL}/payment/nap?page=${page}&limit=${limit}&search=${searched}&startDate=${startStr}&endDate=${endStr}&status=${status}&method=${method}&type=${type}&code=${maGiaoDich}`)
            .then((res) => {
                setData(res.data.data);
                if (res.data.totalPages) {
                    setTotalPages(res.data.totalPages);
                }
                setTotalSuccess(res.data.totalSuccess || 0);
                setTotalPending(res.data.totalPending || 0);
                setTotalFailed(res.data.totalFailed || 0);
                setTotalKm(res.data.totalKm || 0);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };

    const setDatePreset = (preset) => {
        const today = new Date();
        setPage(1);
        switch (preset) {
            case "today": {
                const start = new Date(today);
                setStartDate(start);
                setEndDate(start);
                break;
            }
            case "yesterday": {
                const start = new Date(today);
                start.setDate(today.getDate() - 1);
                setStartDate(start);
                setEndDate(start);
                break;
            }
            case "thisWeek": {
                const start = new Date(today);
                const day = today.getDay();
                const diff = today.getDate() - day + (day === 0 ? -6 : 1);
                start.setDate(diff);
                setStartDate(start);
                setEndDate(today);
                break;
            }
            case "thisMonth": {
                const start = new Date(today.getFullYear(), today.getMonth(), 1);
                setStartDate(start);
                setEndDate(today);
                break;
            }
            case "lastMonth": {
                const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                const end = new Date(today.getFullYear(), today.getMonth(), 0);
                setStartDate(start);
                setEndDate(end);
                break;
            }
            case "all":
            default: {
                setStartDate(null);
                setEndDate(null);
                break;
            }
        }
    };

    useEffect(() => {
        fetchPayments();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, searched, startDate, endDate, status, method, type, maGiaoDich]);

    // Xử lý tìm kiếm Debounce
    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current);
        }
        typingTimeoutRef.current = setTimeout(() => {
            setSearched(value);
            setPage(1); // Chuyển về trang 1 khi search
        }, 500);
    };

    const handleExportExcel = () => {
        if (!data || data.length === 0) {
            swal(t("warning") || "Cảnh báo", "Không có dữ liệu để xuất excel", "warning");
            return;
        }
        const headers = [
            "Tên người chơi",
            "Số điểm",
            "Loại",
            "Trạng thái",
            "Mã giao dịch",
            "Ghi chú",
            "Ngân hàng / Mạng",
            "Số tài khoản / Địa chỉ",
            "Tên tài khoản",
            "Nội dung chuyển khoản",
            "Ngày tạo"
        ];

        const getStatusText = (st) => {
            if (st === "Pending") return "Chờ nạp";
            if (st === "Processing") return "Đang xử lý";
            if (st === "Success" || st === "Accept") return "Thành công";
            if (st === "Deny" || st === "Failed" || st === "Cancel" || st === "Cancelled") return "Thất bại";
            return st || "";
        };

        const rows = data.map((item) => [
            item?.user?.username || "",
            item?.money || 0,
            item?.type || item?.detail || "Nạp tiền",
            getStatusText(item?.status_payment),
            item?.orderNo || item?._id || "-",
            item?.note || "-",
            item?.bank || item?.channel || "MBBank",
            item?.stk || item?.accountNumber || "-",
            item?.name || item?.name_bank || "-",
            item?.code || item?.noidung || "-",
            item?.createdAt ? formatDate(new Date(item?.createdAt)) : ""
        ]);

        const csvContent = [headers, ...rows]
            .map((line) => line.map((val) => `"${String(val).replaceAll('"', '""')}"`).join(","))
            .join("\n");

        const blob = new Blob(["\ufeff", csvContent], { type: "text/csv;charset=utf-8" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `danh-sach-nap-diem-${formatLocalDate(new Date())}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        swal(t("success"), "Đã xuất file excel thành công!", "success");
    };

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <DashboardLayout>
                    <Box
                        component="main"
                        className="happy-finance-page happy-deposit-page"
                        sx={{
                            flexGrow: 1,
                            py: 1
                        }}>
                        {loading ? (
                            <div className="loading" style={{ maxWidth: "100%" }}>
                                <div className="loader"></div>
                            </div>
                        ) : null}
                        <Container maxWidth={false} className="happy-finance-container">
                            <Box className="happy-finance-header" sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                                <div className="ax-sub-tabs" style={{ margin: 0 }}>
                                    <div className="ax-sub-tab active">Danh sách nạp điểm</div>
                                    <Link to="/admin/request" style={{ textDecoration: "none" }}>
                                        <div className="ax-sub-tab">Danh sách rút điểm</div>
                                    </Link>
                                    <div className="ax-sub-tab">Lịch sử duyệt</div>
                                </div>

                                <button className="ax-guide-button" onClick={() => setIsGuideOpen(true)}>
                                    Hướng dẫn <span>?</span>
                                </button>
                            </Box>

                            <div className="form_set happy-finance-surface" style={{ marginTop: 0 }}>
                                <Box>
                                    {/* AX68WIN Filter Block matching Image 1 */}
                                    <div className="happy-finance-filter-block">
                                        <div className="happy-finance-filter-row">
                                            <div className="happy-finance-filter-item item-date">
                                                <label><CalendarMonthRoundedIcon /> Khoảng thời gian</label>
                                                <div className="ax-date-range">
                                                    <DatePicker
                                                        maxDate={new Date()}
                                                        selected={startDate}
                                                        onChange={(date) => {
                                                            setStartDate(date);
                                                            setPage(1);
                                                        }}
                                                        dateFormat="yyyy-MM-dd"
                                                        customInput={<CustomDateInput />}
                                                    />
                                                    <span className="ax-date-separator">→</span>
                                                    <DatePicker
                                                        maxDate={new Date()}
                                                        selected={endDate}
                                                        onChange={(date) => {
                                                            setEndDate(date);
                                                            setPage(1);
                                                        }}
                                                        dateFormat="yyyy-MM-dd"
                                                        customInput={<CustomDateInput />}
                                                    />
                                                    <CalendarMonthRoundedIcon className="ax-date-icon" />
                                                </div>
                                            </div>

                                            <div className="happy-finance-filter-item item-status">
                                                <label><TaskAltRoundedIcon /> Trạng thái</label>
                                                <select
                                                    value={status}
                                                    onChange={(e) => {
                                                        setStatus(e.target.value);
                                                        setPage(1);
                                                    }}
                                                >
                                                    <option value="All">Toàn bộ</option>
                                                    <option value="Pending">Chờ nạp</option>
                                                    <option value="Success">Thành công</option>
                                                    <option value="Deny">Thất bại</option>
                                                </select>
                                            </div>

                                            <div className="happy-finance-filter-item item-method">
                                                <label><CreditCardRoundedIcon /> Phương thức</label>
                                                <select value={method} onChange={(e) => { setMethod(e.target.value); setPage(1); fetchPayments(); }}>
                                                    <option value="All">Toàn bộ</option>
                                                    <option value="Bank">Ngân hàng</option>
                                                    <option value="Crypto">Tiền điện tử</option>
                                                    <option value="USDT">USDT</option>
                                                </select>
                                            </div>

                                            <div className="happy-finance-filter-item item-type">
                                                <label><SyncRoundedIcon /> Loại nạp</label>
                                                <select value={type} onChange={(e) => { setType(e.target.value); setPage(1); fetchPayments(); }}>
                                                    <option value="All">Toàn bộ</option>
                                                    <option value="Manual">Thủ công</option>
                                                    <option value="Auto">Tự động</option>
                                                </select>
                                            </div>

                                            <div className="happy-finance-filter-item item-user">
                                                <label><PersonOutlineRoundedIcon /> Tên người chơi</label>
                                                <input
                                                    type="text"
                                                    placeholder="Tên người chơi"
                                                    onChange={handleSearchChange}
                                                />
                                            </div>

                                            <div className="happy-finance-filter-item item-code">
                                                <label><NumbersRoundedIcon /> Mã giao dịch</label>
                                                <input
                                                    type="text"
                                                    placeholder="Mã giao dịch"
                                                    value={maGiaoDich}
                                                    onChange={(e) => setMaGiaoDich(e.target.value)}
                                                />
                                            </div>

                                            <div className="happy-finance-filter-actions">
                                                <button className="happy-finance-btn-search" onClick={() => { setPage(1); fetchPayments(); }}>
                                                    <SearchRoundedIcon style={{ fontSize: 18 }} /> Tìm kiếm
                                                </button>
                                                <button className="happy-finance-btn-excel" onClick={handleExportExcel}>
                                                    <FileDownloadRoundedIcon style={{ fontSize: 18 }} /> Xuất exel
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 4 Summary Status Cards matching Image 1 */}
                                    <div className="happy-finance-summary-grid">
                                        <div className="happy-finance-card card-blue">
                                            <div>
                                                <div className="card-title">Chờ nạp</div>
                                                <div className="card-val-row">
                                                    <AccessTimeRoundedIcon style={{ fontSize: 20 }} />
                                                    <span>{Math.floor((totalPending || 0) / 1000).toLocaleString("en-US")}</span>
                                                </div>
                                            </div>
                                            <div className="card-icon-badge">
                                                <AccessTimeRoundedIcon />
                                            </div>
                                        </div>

                                        <div className="happy-finance-card card-yellow">
                                            <div>
                                                <div className="card-title">Chờ kiểm tra</div>
                                                <div className="card-val-row">
                                                    <AssignmentRoundedIcon style={{ fontSize: 20 }} />
                                                    <span>0</span>
                                                </div>
                                            </div>
                                            <div className="card-icon-badge">
                                                <AssignmentRoundedIcon />
                                            </div>
                                        </div>

                                        <div className="happy-finance-card card-green">
                                            <div>
                                                <div className="card-title">Thành công</div>
                                                <div className="card-val-row">
                                                    <TaskAltRoundedIcon style={{ fontSize: 20 }} />
                                                    <span>{Math.floor((totalSuccess || 0) / 1000).toLocaleString("en-US")}</span>
                                                </div>
                                            </div>
                                            <div className="card-icon-badge">
                                                <TaskAltRoundedIcon />
                                            </div>
                                        </div>

                                        <div className="happy-finance-card card-red">
                                            <div>
                                                <div className="card-title">Thất bại</div>
                                                <div className="card-val-row">
                                                    <CancelRoundedIcon style={{ fontSize: 20 }} />
                                                    <span>{Math.floor((totalFailed || 0) / 1000).toLocaleString("en-US")}</span>
                                                </div>
                                            </div>
                                            <div className="card-icon-badge">
                                                <CancelRoundedIcon />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ax-table-wrapper happy-finance-table">
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Tên người chơi</TableCell>
                                                    <TableCell>Số điểm</TableCell>
                                                    <TableCell>Loại</TableCell>
                                                    <TableCell>Trạng thái</TableCell>
                                                    <TableCell>Mã giao dịch</TableCell>
                                                    <TableCell>Ghi chú</TableCell>
                                                    <TableCell>Ngân hàng/<br />Mạng</TableCell>
                                                    <TableCell>Số tài khoản/<br />Địa chỉ</TableCell>
                                                    <TableCell>Tên tài khoản</TableCell>
                                                    <TableCell>Nội dung chuyển khoản</TableCell>
                                                    <TableCell>Ngày tạo</TableCell>
                                                    <TableCell>Tác vụ</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            {data != null && data.length > 0 ? (
                                                <TableBody>
                                                    {data.map((item, index) => {
                                                        let { cleanNote, extractedCode } = parseTransactionInfo(item);
                                                        const orderNum = (item?.orderNo && /^\d+$/.test(item.orderNo)) ? item.orderNo : (5678 - ((page - 1) * limit + index));
                                                        let displayType = getDepositTypeLabel(item);

                                                        let displayBank = item?.bank || item?.channel || "-";
                                                        if (displayBank === "Manual Deposit") {
                                                            displayBank = "Ngân hàng thủ công";
                                                            if (!extractedCode && item?.detail && item.detail.toLowerCase() !== "usdt") {
                                                                extractedCode = item.detail;
                                                            }
                                                        }

                                                        return (
                                                            <TableRow key={item._id}>
                                                                <TableCell><span className="ax-username-link">{item?.user?.username}</span></TableCell>
                                                                <TableCell><span className="ax-money-green">{(Number(item?.money || 0) / 1000).toLocaleString("en-US")}</span></TableCell>
                                                                <TableCell><span className="happy-type-badge">{displayType}</span></TableCell>
                                                                <TableCell>
                                                                    {(item?.status_payment === "Success" || item?.status_payment === "Accept") && (
                                                                        <span className="ax-badge success"><CheckCircleOutlineRoundedIcon style={{ fontSize: 14 }} /> Thành công</span>
                                                                    )}
                                                                    {(item?.status_payment === "Deny" || item?.status_payment === "Failed" || item?.status_payment === "Cancel" || item?.status_payment === "Cancelled") && (
                                                                        <span className="ax-badge failed"><HighlightOffRoundedIcon style={{ fontSize: 14 }} /> Thất bại</span>
                                                                    )}
                                                                    {(item?.status_payment === "Pending" || item?.status_payment === "Processing") && (
                                                                        <span className="ax-badge pending"><AccessTimeRoundedIcon style={{ fontSize: 14 }} /> Chờ nạp</span>
                                                                    )}
                                                                    {!["Pending", "Processing", "Success", "Accept", "Deny", "Failed", "Cancelled", "Cancel"].includes(item?.status_payment) && (
                                                                        <span className="ax-badge">{item?.status_payment || "N/A"}</span>
                                                                    )}
                                                                </TableCell>
                                                                <TableCell><span className="happy-trans-badge">{orderNum}</span></TableCell>
                                                                <TableCell><span className="happy-note-text">{cleanNote}</span></TableCell>
                                                                <TableCell><span className="ax-bank-name">{mapBankName(displayBank)}</span></TableCell>
                                                                <TableCell><span className="ax-account-num">{item?.stk || item?.accountNumber || "-"}</span></TableCell>
                                                                <TableCell>{item?.name || item?.name_bank || "-"}</TableCell>
                                                                <TableCell>{extractedCode ? <span className="happy-code-badge">{extractedCode}</span> : "-"}</TableCell>
                                                                <TableCell><span className="ax-date-text">{formatDate(new Date(item?.createdAt))}</span></TableCell>
                                                                <TableCell>
                                                                    <button className="happy-btn-detail" onClick={() => setSelectedDetailItem({ ...item, _orderSeq: orderNum })}>
                                                                        <VisibilityRoundedIcon style={{ fontSize: 14 }} /> Chi tiết
                                                                    </button>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                            ) : (
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell colSpan={12} align="center">{t("empty")}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            )}
                                        </Table>
                                    </div>
                                </Box>
                            </div>
                            <Box sx={{ display: "flex", justifyContent: "center", pt: 3 }}>
                                {data != null ? <Pagination color="primary" page={page} count={totalPages} size="small" onChange={handleChangePage} /> : null}
                            </Box>
                        </Container>
                    </Box>

                    {/* DETAIL MODAL - AX68WIN MATCHING 3-COLUMN LAYOUT */}
                    {selectedDetailItem && (() => {
                        const parsed = parseDetailTransaction(selectedDetailItem);
                        return (
                            <div className="happy-detail-modal-overlay" onClick={() => setSelectedDetailItem(null)}>
                                <div className="happy-detail-modal-card" onClick={(e) => e.stopPropagation()}>
                                    <div className="happy-detail-modal-header">
                                        <h3>Mã giao dịch: {selectedDetailItem?._orderSeq || selectedDetailItem?.orderNo || "-"}</h3>
                                        <span className="close-btn" onClick={() => setSelectedDetailItem(null)}>✕</span>
                                    </div>
                                    <div className="happy-detail-modal-body">
                                        {/* Cột 1 (5 dòng) */}
                                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Tên người chơi:</span>
                                                <span className="val">{selectedDetailItem?.user?.username || "-"}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Ngân hàng / Mạng:</span>
                                                <span className="val">{parsed.bankName}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Mã mời:</span>
                                                <span className="val">{selectedDetailItem?.user?.inviteCode || "-"}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Ngày tạo:</span>
                                                <span className="val">{formatDate(new Date(selectedDetailItem?.createdAt))}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Loại:</span>
                                                <span className="happy-blue-pill">{parsed.methodType}</span>
                                            </div>
                                        </div>

                                        {/* Cột 2 (5 dòng) */}
                                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Số điểm:</span>
                                                <span className="val">{(Number(selectedDetailItem?.money || 0) / 1000).toLocaleString("en-US")}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Số tài khoản / Địa chỉ:</span>
                                                <span className="val">{parsed.accountNumber}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Nội dung chuyển khoản:</span>
                                                <span className="val">{parsed.codeText}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Ngày cập nhật:</span>
                                                <span className="val">{formatDate(new Date(selectedDetailItem?.updatedAt || selectedDetailItem?.createdAt))}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Trạng thái:</span>
                                                <span className="val">
                                                    {(selectedDetailItem?.status_payment === "Success" || selectedDetailItem?.status_payment === "Accept") && (
                                                        <span className="ax-badge success"><CheckCircleOutlineRoundedIcon style={{ fontSize: 14 }} /> Thành công</span>
                                                    )}
                                                    {(selectedDetailItem?.status_payment === "Deny" || selectedDetailItem?.status_payment === "Failed" || selectedDetailItem?.status_payment === "Cancel" || selectedDetailItem?.status_payment === "Cancelled") && (
                                                        <span className="ax-badge failed"><HighlightOffRoundedIcon style={{ fontSize: 14 }} /> Thất bại</span>
                                                    )}
                                                    {selectedDetailItem?.status_payment === "Pending" && (
                                                        <span className="ax-badge pending"><AccessTimeRoundedIcon style={{ fontSize: 14 }} /> Chờ nạp</span>
                                                    )}
                                                    {selectedDetailItem?.status_payment === "Processing" && (
                                                        <span className="ax-badge processing"><AccessTimeRoundedIcon style={{ fontSize: 14 }} /> Đang xử lý</span>
                                                    )}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Cột 3 (5 dòng) */}
                                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Yêu cầu khuyến mãi:</span>
                                                <span className="val">{selectedDetailItem?.km ? selectedDetailItem.km : "-"}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Loại nạp:</span>
                                                <span className="happy-type-pill-green">{parsed.displayType}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Tên tài khoản:</span>
                                                <span className="val">{parsed.accountName}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Ghi chú:</span>
                                                <span className="val">{parsed.cleanNote}</span>
                                            </div>
                                            <div className="happy-modal-line">
                                                <span className="lbl">Cập nhật bởi:</span>
                                                <span className="val">{selectedDetailItem?.adminUpdated || "-"}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="happy-detail-modal-footer">
                                        {(selectedDetailItem?.status_payment === "Pending" || selectedDetailItem?.status_payment === "Processing") && (profile?.isAdmin || profile?.permission?.money == 1) ? (
                                            <>
                                                <button
                                                    type="button"
                                                    style={{ background: "#1677ff", backgroundColor: "#1677ff", color: "#ffffff", border: "none", borderRadius: "6px", fontWeight: 500, padding: "0 15px", height: "32px", fontSize: "14px", cursor: "pointer" }}
                                                    onClick={() => {
                                                        setLoading(true);
                                                        axios.post(`${process.env.REACT_APP_API_URL}/payment/update`, { id: selectedDetailItem?._id, status: "Accept", note: "Duyệt thủ công", is_manual: true })
                                                            .then((res) => {
                                                                if (res.data?.success === false) {
                                                                    swal(t("error"), res.data?.message || "Duyệt đơn thất bại", "error");
                                                                } else {
                                                                    swal(t("success"), "Duyệt đơn nạp thành công!", "success");
                                                                }
                                                                setSelectedDetailItem(null);
                                                                fetchPayments();
                                                            })
                                                            .catch((err) => {
                                                                swal(t("error"), err.response?.data?.message || "Duyệt đơn thất bại", "error");
                                                                setSelectedDetailItem(null);
                                                                fetchPayments();
                                                            });
                                                    }}>
                                                    Duyệt nạp thủ công
                                                </button>
                                                <button
                                                    type="button"
                                                    style={{ color: "rgba(0,0,0,0.88)", borderColor: "#d9d9d9", border: "1px solid #d9d9d9", background: "#ffffff", borderRadius: "6px", fontWeight: 400, padding: "0 15px", height: "32px", fontSize: "14px", cursor: "pointer" }}
                                                    onClick={() => {
                                                        setDenyItem(selectedDetailItem);
                                                        setDenyReason("");
                                                        setDenyModalOpen(true);
                                                    }}>
                                                    Hủy bỏ
                                                </button>
                                            </>
                                        ) : (
                                            <>
                                                <button
                                                    type="button"
                                                    disabled
                                                    style={{ backgroundColor: "#f5f5f5", color: "rgba(0,0,0,0.25)", borderColor: "#d9d9d9", border: "1px solid #d9d9d9", padding: "0 15px", height: "32px", borderRadius: "6px", fontSize: "14px", cursor: "not-allowed" }}>
                                                    Duyệt nạp thủ công
                                                </button>
                                                <button
                                                    type="button"
                                                    disabled
                                                    style={{ backgroundColor: "#ffffff", color: "rgba(0,0,0,0.25)", borderColor: "#d9d9d9", border: "1px solid #d9d9d9", padding: "0 15px", height: "32px", borderRadius: "6px", fontSize: "14px", cursor: "not-allowed" }}>
                                                    Hủy bỏ
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })()}
                    {/* DENIAL REASON MODAL POPUP - MATCHING USER REFERENCE SCREENSHOT */}
                    {denyModalOpen && denyItem && (
                        <div className="happy-detail-modal-overlay" onClick={() => setDenyModalOpen(false)}>
                            <div
                                className="happy-detail-modal-card"
                                style={{ width: "460px", maxWidth: "90vw", borderRadius: "8px", padding: "20px 24px", boxSizing: "border-box" }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {/* Header */}
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                                    <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1f2937" }}>
                                        Hủy bỏ giao dịch
                                    </h3>
                                    <span
                                        className="close-btn"
                                        style={{ cursor: "pointer", fontSize: "16px", color: "#9ca3af", display: "flex", alignItems: "center", justifyContent: "center", width: "24px", height: "24px" }}
                                        onClick={() => setDenyModalOpen(false)}
                                    >
                                        ✕
                                    </span>
                                </div>

                                {/* Input Lý do hủy bỏ */}
                                <div style={{ marginBottom: "16px" }}>
                                    <label style={{ display: "block", fontSize: "14px", fontWeight: 500, color: "#374151", marginBottom: "8px" }}>
                                        Lý do hủy bỏ
                                    </label>
                                    <input
                                        type="text"
                                        value={denyReason}
                                        onChange={(e) => setDenyReason(e.target.value)}
                                        style={{
                                            width: "100%",
                                            height: "40px",
                                            padding: "0 12px",
                                            borderRadius: "6px",
                                            border: "1px solid #d9d9d9",
                                            fontSize: "14px",
                                            color: "#1f2937",
                                            outline: "none",
                                            boxSizing: "border-box"
                                        }}
                                    />
                                </div>

                                {/* Lý do gần đây */}
                                <div style={{ marginBottom: "24px" }}>
                                    <label style={{ display: "block", fontSize: "14px", fontWeight: 500, color: "#374151", marginBottom: "8px" }}>
                                        Lý do gần đây
                                    </label>
                                    <div style={{ display: "flex", flexDirection: "column", gap: "8px", maxHeight: "200px", overflowY: "auto" }}>
                                        {recentReasons.map((reasonStr, index) => {
                                            const isSelected = denyReason === reasonStr;
                                            return (
                                                <div
                                                    key={index}
                                                    onClick={() => setDenyReason(reasonStr)}
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        height: "40px",
                                                        padding: "0 12px",
                                                        borderRadius: "6px",
                                                        border: isSelected ? "1px solid #52c41a" : "1px solid #d9d9d9",
                                                        background: "#ffffff",
                                                        cursor: "pointer",
                                                        fontSize: "13px",
                                                        fontWeight: 500,
                                                        color: "#262626",
                                                        transition: "all 0.2s"
                                                    }}
                                                >
                                                    <span>{reasonStr}</span>
                                                    <span
                                                        onClick={(e) => deleteReason(reasonStr, e)}
                                                        style={{
                                                            color: "#ff4d4f",
                                                            cursor: "pointer",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            fontSize: "14px",
                                                            padding: "4px"
                                                        }}
                                                        title="Xóa lý do này"
                                                    >
                                                        🗑
                                                    </span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>

                                {/* Footer Buttons */}
                                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                                    <button
                                        type="button"
                                        onClick={() => setDenyModalOpen(false)}
                                        style={{
                                            height: "36px",
                                            padding: "0 16px",
                                            borderRadius: "6px",
                                            border: "1px solid #d9d9d9",
                                            background: "#ffffff",
                                            color: "rgba(0, 0, 0, 0.88)",
                                            fontSize: "14px",
                                            fontWeight: 400,
                                            cursor: "pointer"
                                        }}
                                    >
                                        Hủy bỏ
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => handleConfirmDeny(denyItem, denyReason)}
                                        style={{
                                            height: "36px",
                                            padding: "0 16px",
                                            borderRadius: "6px",
                                            border: "none",
                                            background: "#ef4444",
                                            color: "#ffffff",
                                            fontSize: "14px",
                                            fontWeight: 500,
                                            cursor: "pointer"
                                        }}
                                    >
                                        Xác nhận hủy bỏ giao dịch
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </DashboardLayout>
            </ThemeProvider>
        </>
    );
}
export default Add;
